import { useState, useEffect } from 'react';

export function useAPI() {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAssets = async () => {
    try {
      setLoading(true);
      let response;
      if(window.location.hostname === 'localhost') {
        response = await fetch(`http://localhost:3001/api/assets`);
      } else {
        response = await fetch(`/api/assets`);
      }
      if (!response.ok) {
        setLoading(false);
        setError(`Failed to fetch assets: ${response.status} ${response.statusText}`);
        throw new Error(`Failed to fetch assets: ${response.status} ${response.statusText}`);
      }
      setLoading(false);
      const fetchedAssets = await response.json();
      setAssets(fetchedAssets);
    } catch (err) {
      setLoading(false);
      setError(`Failed to fetch assets: ${err}`);
      throw new Error(`Failed to fetch assets: ${err}`);
    }
  };

  useEffect(() => {
    if(assets.length === 0 && !loading) {
      fetchAssets();
    }
  }, []);

  return {
    assets,
    loading,
    error,
  };
}

export default useAPI;